import React,{useState, useEffect} from 'react';

import Sides from '../Bars/Pythonsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
 

function Pvariable(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 


return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Variables Beginners Tutorials CodeExampler</title>
<meta name="description" content="Learn Free Python Variables Beginners Tutorials CodeExampler.Variable is the name of a memory location in which we can store the value" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python variables,add python values,python class variables,python increment variables,python global variables, Python variable class ,Python variable declaration ,Python variable exercises ,Python variable global,Python variable" />
<link rel="canonical" href="https://www.codeexampler.com/python-variables/"/>
</Helmet>


<div className='lg:pl-56'>
    <h1 className="m-4 mh1">Python variables</h1>

    <div className="first">
       
        <a href="/python-types-of-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <h2 className="mt-4 mh2">What is python variable, and how is Python variable declaration </h2>
    <p className="pt-3 para ">
    1, Variable is the name of a memory location in which we can store the value <br/>
2, python variable can change the variable value<br/>
3, A variable is defined by combining an identifier, data types, and an initializer.<br/>
4, The first character in the variable name must be an alphabet, underscore, a digit, or 
a dollar sign. <br/>
5, All variables have a scope<br/>
6, The identifier is the name of the variable<br/>
 7, Commas or blanks not used inside a variable name

    </p>



<h2 className='headings'>Python Variable Declaration Syntax:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">variable-name</span>
                <span className="qwerty-9"> =</span>
                <span className="qwerty-8"> assigned value</span>
                {"\n"}
                <span className="qwerty"> x</span>
                <span className="qwerty-9"> =</span>
                <span className="qwerty-11"> 5</span>
                {"\n"}
                <span className="qwerty"> x </span>
                <span className="qwerty-10">is a </span>
                <span className="qwerty-6">Variable Name</span>
            {"\n"}
                <span className="qwerty-1"> =</span>
                <span className="qwerty-10"> is a </span>
                <span className="qwerty-6">Assignment Operator</span>
            {"\n"}
                <span className="qwerty-11"> 5</span>
                <span className="qwerty-10"> is a</span>
                <span className="qwerty-6"> Assigned Value </span>
                <span className="qwerty-10">to the</span>
                <span className="qwerty-3"> Variable Name </span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>

<h2 className="mt-4 mh2">Addition of Variables Examples:</h2>


<h2 className='headings'>Q-Write a Program Add 4 variables in Python?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">=</span>
                <span className="qwerty-8">10</span>
                <span className="qwerty-10">;</span>
                <span className="qwerty-4"> b</span>
                <span className="qwerty-1">=</span>
                <span className="qwerty-8">20</span>
                <span className="qwerty-10">;</span>
                <span className="qwerty-4"> c</span>
                <span className="qwerty-10">=</span>
                <span className="qwerty-8">30</span>
                <span className="qwerty-10">;</span>
                <span className="qwerty-4"> d</span>
                <span className="qwerty-1">=</span>
                <span className="qwerty-8">40</span>
                <span className="qwerty-10">;</span>
                {"\n"}
                <span className="qwerty-3">print</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty">+</span>
                <span className="qwerty-4">b</span>
                <span className="qwerty">+</span>
                <span className="qwerty-4">c</span>
                <span className="qwerty">+</span>
                <span className="qwerty-4">d</span>
                <span className="qwerty-10">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-2">100</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>



<h2 className='headings'>Q-Variable increment values in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">10</span>
                 {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">+</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">40</span>
                 {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-8">20</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-10">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">70</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>



<h2 className='headings'>Q-Create a variable and store ano inside this variable and print output?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">40</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-10">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">40</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


<h2 className="mt-4 mh2">Create Variable String Type: </h2>



<h2 className='headings'>Q-Create a string variable and store a no inside string type vaiable and print output?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">="</span>
                 <span className="qwerty-8">Ram</span>
                 <span className="qwerty-1">"</span>
                 {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">="</span>
                 <span className="qwerty-8">Lakshman</span>
                 <span className="qwerty-1">"</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-1">" "</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-10">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">Ram Lakshman</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


<h2 className="mt-4 mh2"> Another String type Example:</h2>


<h2 className='headings'>Q-Create a string variable and store a no inside string type vaiable and print output?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">="</span>
                 <span className="qwerty-8">Ram</span>
                 <span className="qwerty-1">"</span>
                 {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">="</span>
                 <span className="qwerty-8">Lakshman</span>
                 <span className="qwerty-1">"</span>
                 {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">="</span>
                 <span className="qwerty-8">my name is a codeexampler 160208</span>
                 <span className="qwerty-1">"</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-1">" "</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-1">" "</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-10">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">Ram Lakshman my name is a codeexampler 160208</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
              
       
         
     </div>

<h2 className="mt-4 mh2">Constant:</h2>

<p className="para mt-4">Constant is use when you store a value inside a variable but use constant after you can’t overwrite the existing deal.
</p>

  <h1 className="mt-5"> </h1>
    
  <div className="back">
        
        <a href="/python-types-of-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Pvariable;